<template>
    <div class="menu-item-spin">
        <div v-if="Summed" class="sum-container" :class=" MenuItem.sum > 0 ? 'visible' : ''">
            <span>{{ (MenuItem.sum  /100 ).toFixed(2) }}</span>
        </div>
        <div class="button-container">
            <button v-if="this.MenuItem.qty == 0" @click="inc" class="spin-button">В избранное</button>
            <div v-else>
                <button class="spin-button spin-button-spin" @click="dec"><svg class="rotate-l" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"/><path d="M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20 M12,22c5.52,0,10-4.48,10-10c0-5.52-4.48-10-10-10 C6.48,2,2,6.48,2,12C2,17.52,6.48,22,12,22L12,22z M11,12l0,4h2l0-4h3l-4-4l-4,4H11z"/></g></svg></button>
                <span v-if="(this.MenuItem.rests > 0) && (this.MenuItem.qty > 0)" class="spin-value">{{ MenuItem.qty }} / {{ MenuItem.rests }}</span>
                <span v-else class="spin-value"> {{ MenuItem.qty }} </span>
                <button class="spin-button spin-button-spin" @click="inc"><svg  xmlns="http://www.w3.org/2000/svg" class="rotate-r" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><rect fill="none" height="24" width="24"/><path d="M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20 M12,22c5.52,0,10-4.48,10-10c0-5.52-4.48-10-10-10 C6.48,2,2,6.48,2,12C2,17.52,6.48,22,12,22L12,22z M11,12l0,4h2l0-4h3l-4-4l-4,4H11z"/></g></svg></button>
                <button  class="spin-button spin-button-spin" @click="MenuItem.qty = 0"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['MenuItem', 'Summed'],
    methods:{
        inc: function (){
            if (this.MenuItem.qty){
                if (this.MenuItem.rests < 0) {
                    this.MenuItem.qty += 1
                } else if (((this.MenuItem.rests) - (this.MenuItem.qty + 1)) >= 0) {
                    this.MenuItem.qty += 1
                }
            } else {
                this.MenuItem.qty = 1
            }
            this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
        },
        dec: function (){
            if (this.MenuItem.qty){
                if (this.MenuItem.qty > 0){
                    this.MenuItem.qty -= 1
                }
                this.MenuItem.sum = this.MenuItem.price * this.MenuItem.qty
            }
        }
    }
}
</script>